var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"RejectionBlock"}},[_c('div',[_c('h2',[_vm._v("Уважаемый клиент!")]),_c('p',[_vm._v("У Вас уже есть заявка на рассмотрении. Дождитесь, пожалуйста, завершения")])])])
}]

export { render, staticRenderFns }